import * as api from '../api/index';

const initAppAction = ({ commit }, payload ) => {
    commit('setState', payload)
}

const getCategoriesAction = ({ commit, state }) => {
    api.getCategories(state)
        .then(res => {
            commit('setCategories', res || []);
        })
}

const submitFormAction = ({ commit, state }, payload) => {
    commit('setLoading', true);
    api.submit(state, payload)
        .then((res) => {
            commit('setMessage', res);
            commit('setShowMessage', true);
            if(res.success) {
                document.querySelector('.create-visit-form__form').reset();
            }
            commit('setLoading', false);
            setTimeout(() => commit('setShowMessage'), 8000)
        })
}

const actions = {
    initApp: initAppAction,
    getCategories: getCategoriesAction,
    submitForm: submitFormAction,
};

export default actions;